/***
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-07-30 19:37:01
 * @FilePath: \gcp-fe\src\mixins\mixin-common\mixin-homePage.js
 * @Description:
 */
import globalCofig from "@/setting/setting";
import { encBlackList, querySupJoinFlag } from "@/app/shop/api/shopping";
// import { addUrlPerFix } from "@/basa/utils";
import Cookies from "js-cookie";
// \app\procurementNotice\js\formOptions.js
import formOptions from "@/app/procurementNotice/js/formOptions";
import store from "@/config/store";

export const mixinHomePage = {
  data() {
    return {
      formOptions
    };
  },
  deactivated() {},
  methods: {
    //我要报名
    signUp(row, str) {
      if (this.checkFlag === "5") {
        this.$message({
          showClose: true,
          message: "该公告您已报过名了",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
        return false;
      }
      row.supCode = row.supCode ? row.supCode : "";
      row.supName = row.supName ? row.supName : "";
      window.open(
        `${this.$addUrlPerFix(process.env.VUE_APP_BM_URL)}/purchase?schemeId=${
          row.schemeId
        }&purchaseType=${row.purchaseType}&noticeStartTime=${
          row.noticeStartTime
        }&schemeName=${encodeURIComponent(
          row.schemeName
        )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
          row.supCode
        }&source=3`,
        "_blank"
      );
      // window.open(
      //   this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
      //     "?CLIENT_ID=" +
      //     globalCofig.agentId +
      //     "&CALLBACK_URL=" +
      //     encodeURIComponent(
      //       `${this.$addUrlPerFix(
      //         process.env.VUE_APP_BID_URL
      //       )}/shop/participate?schemeId=${row.schemeId}&purchaseType=${
      //         row.purchaseType
      //       }&noticeStartTime=${
      //         row.noticeStartTime
      //       }&schemeName=${encodeURIComponent(
      //         row.schemeName
      //       )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
      //         row.supCode
      //       }&a=${globalCofig.agentId}`
      //     ),
      //   "_blank"
      // );
    },
    //我要报名分包
    signUpFB(row) {
      if (this.checkFlag === "5") {
        this.$message({
          showClose: true,
          message: "该公告您已报过名了",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
        return false;
      }

      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_CRMSA_URL
            )}/bid/shop/participateSub?schemeId=${row.schemeId}&purchaseType=${
              row.purchaseType
            }&noticeStartTime=${
              new Date(row.noticeStartTime).getTime()
              // row.noticeStartTime
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
              row.supCode
            }&supName=${row.supName}&a=${
              JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
              // sessionStorage.getItem("param_a")
              // JSON.parse(localStorage.usedSupInfo)?.secretAgentId
            }`
          ),
        "_blank"
      );
    },
    toProject(obj) {
      window.open(
        `${this.$addUrlPerFix(
          process.env.VUE_APP_CRMA_URL
        )}/bid/bidFlowIndex?schemeId=${obj.schemeId}&noticeStartTime=${
          obj.noticeStartTime
        }&noticeEndTime=${obj.noticeEndTime}&schemeName=${encodeURIComponent(
          obj.schemeName
        )}&schemeCode=${obj.schemeCode}&supCode=${obj.supCode}&purchaseType=${
          obj.purchaseType
        }&supplierFlag=0&a=` + sessionStorage.getItem("param_a")
      );
    },
    toProjectFB(obj) {
      window.open(
        `${this.$addUrlPerFix(
          process.env.VUE_APP_CRMSA_URL
        )}/bid/bidFlowIndexSub?schemeId=${obj.schemeId}&noticeStartTime=${
          obj.noticeStartTime
        }&noticeEndTime=${obj.noticeEndTime}&schemeName=${
          obj.schemeName
        }&schemeCode=${obj.schemeCode}${
          obj.supCode ? "&supCode=" + obj.supCode : ""
        }&supName=${obj.supName}&purchaseType=${
          obj.purchaseType
        }&supplierFlag=1&a=${
          JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
        }`
      );
    },
    toProjectLocation(obj) {
      window.location.href =
        `${this.$addUrlPerFix(
          process.env.VUE_APP_CRMA_URL
        )}/bid/bidFlowIndex?schemeId=${obj.schemeId}&noticeStartTime=${
          obj.noticeStartTime
        }&noticeEndTime=${obj.noticeEndTime}&schemeName=${encodeURIComponent(
          obj.schemeName
        )}&schemeCode=${obj.schemeCode}&supCode=${obj.supCode}&purchaseType=${
          obj.purchaseType
        }&supplierFlag=0&a=` + sessionStorage.getItem("param_a");
    },
    //进入项目
    perform(row) {
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          globalCofig.agentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_CRMA_URL
            )}/bid/bidFlowIndex?schemeId=${row.schemeId}&noticeStartTime=${
              row.noticeStartTime
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
              row.supCode
            }&supName=${encodeURIComponent(row.supName)}&a=${
              globalCofig.agentId
            }&purchaseType=${row.purchaseType}&supplierFlag=0&a=` +
              sessionStorage.getItem("param_a")
          ),
        "_blank"
      );
    },
    //查看详情
    handleView(row, tabName) {
      if (row.dataSourceFlag == 3 || row.dataSourceFlag == 4) {
        // 跳转新加的页面 3融合专区（采购类 4, "融合专区（分包类
        let url = this.$router.resolve({
          path: "viewNoticeDetailNew",
          query: {
            // schemeId: row.schemeId,
            baseAppId: row.baseAppId,
            // schemeCode: row.schemeCode,
            // schemeName: row.schemeName,
            noticeId: row.noticeId
            // opUnitName: row.opUnitName,
            // opUnitId: row.opUnitId,
            // purchaseType: row.purchaseType,
            // schemeStatus: row.schemeStatus,
            // checkFlag: row.checkFlag,
            // supCode: row.supCode,
            // supName: row.supName,
            // type: row.noticeType
          }
        });
        window.location.href = url.href;
      } else {
        if (tabName == 7 || tabName == 8) {
          let url = this.$router.resolve({
            path:
              tabName == 7 || tabName == 8
                ? "viewNoticeSimpleDetail"
                : "/viewNoticeDetail",
            query: {
              type: tabName,
              schemeId: row.schemeId,
              schemeCode: row.schemeCode,
              schemeName: row.schemeName,
              noticeId: row.noticeId,
              opUnitName: row.opUnitName,
              opUnitId: row.opUnitId,
              purchaseType: row.purchaseType,
              schemeStatus: row.schemeStatus,
              checkFlag: row.checkFlag,
              supCode: row.supCode,
              supName: row.supName
              // isJRZL: 1,
              // searchType: "采购公告"
            }
          });
          window.location.href = url.href;
        } else {
          if (["107407", "118352", "119934"].includes(row.baseAppId)) {
            //租赁
            let url =
              this.$addUrlPerFix(process.env.VUE_APP_YZ_URL) +
              "/leaseMall/viewNoticeDetail?" +
              "schemeId=" +
              row.schemeId +
              "&schemeCode=" +
              row.schemeCode +
              "&schemeName=" +
              encodeURIComponent(row.schemeName) +
              "&noticeId=" +
              row.noticeId +
              "&opUnitName=" +
              row.opUnitName +
              "&opUnitId=" +
              row.opUnitId +
              "&purchaseType=" +
              "" +
              row.purchaseType +
              "&schemeStatus=" +
              row.schemeStatus +
              "&checkFlag=" +
              row.checkFlag +
              "&supCode=" +
              row.supCode +
              "&supName=" +
              row.supName;
            window.open(url, "_blank");
            return;
          } else if (["118353", "107412", "119952"].includes(row.baseAppId)) {
            //物流
            let url =
              this.$addUrlPerFix(process.env.VUE_APP_WLY_URL) +
              "/#/detail?" +
              "schemeId=" +
              row.schemeId +
              "&schemeCode=" +
              row.schemeCode +
              "&schemeName=" +
              encodeURIComponent(row.schemeName) +
              "&noticeId=" +
              row.noticeId +
              "&opUnitName=" +
              row.opUnitName +
              "&opUnitId=" +
              row.opUnitId +
              "&purchaseType=" +
              "" +
              row.purchaseType +
              "&schemeStatus=" +
              row.schemeStatus +
              "&checkFlag=" +
              row.checkFlag +
              "&supCode=" +
              row.supCode +
              "&supName=" +
              row.supName;
            window.open(url, "_blank");
            return;
          } else if (["107428", "118497", "119912"].includes(row.baseAppId)) {
            //云仓
            let url =
              this.$addUrlPerFix(process.env.VUE_APP_YC_URL) +
              `/leaseMall/viewNoticeDetail?schemeId=${row.schemeId}&noticeId=${row.noticeId}&schemeCode=${row.schemeCode}&schemeName=${row.schemeName}`;
            window.open(url, "_blank");
            return;
          } else if (["100065"].includes(row.baseAppId)) {
            // 分包 /fenBaoDetail
            let objSession = {};
            if (
              sessionStorage.getItem("usedSupInfo") &&
              sessionStorage.getItem("usedSupInfo") != "undefined"
            ) {
              objSession = JSON.parse(sessionStorage.getItem("usedSupInfo"));
            }
            if (objSession?.supCode && Cookies.get("access_token")) {
              querySupJoinFlag({
                schemeId: row.schemeId,
                supCode: objSession.supCode
              }).then(res => {
                if (res.data.data.isJoin == 1) {
                  console.log(
                    this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                      "?CLIENT_ID=" +
                      JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                      "&CALLBACK_URL=" +
                      encodeURIComponent(
                        `${this.$addUrlPerFix(
                          process.env.VUE_APP_CRMSA_URL
                        )}/bid/bidFlowIndexSub?schemeId=${
                          row.schemeId
                        }&noticeStartTime=${new Date(
                          row.noticeTimeStart
                        ).getTime()}&noticeEndTime=${
                          // row.noticeTimeEnd
                          new Date(row.noticeTimeEnd).getTime()
                        }&schemeName=${row.schemeName}&schemeCode=${
                          row.schemeCode
                        }${
                          this.supCode || row.supCode || objSession.supCode
                            ? "&supCode=" +
                              (this.supCode ||
                                row.supCode ||
                                objSession.supCode)
                            : ""
                        }&supName=${
                          JSON.parse(sessionStorage.usedSupInfo)?.supName
                        }&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                          JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                        }`
                      ),
                    "url"
                  );
                  return window.open(
                    this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                      "?CLIENT_ID=" +
                      JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                      "&CALLBACK_URL=" +
                      encodeURIComponent(
                        `${this.$addUrlPerFix(
                          process.env.VUE_APP_CRMSA_URL
                        )}/bid/bidFlowIndexSub?schemeId=${
                          row.schemeId
                        }&noticeStartTime=${new Date(
                          row.noticeTimeStart
                        ).getTime()}&noticeEndTime=${
                          new Date(row.noticeTimeEnd).getTime()
                          // row.noticeTimeEnd
                        }&schemeName=${row.schemeName}&schemeCode=${
                          row.schemeCode
                        }${
                          this.supCode || row.supCode || objSession.supCode
                            ? "&supCode=" +
                              (this.supCode ||
                                row.supCode ||
                                objSession.supCode)
                            : ""
                        }&supName=${
                          JSON.parse(sessionStorage.usedSupInfo)?.supName
                        }&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                          JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                        }`
                      )
                    // addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                    //   "?CLIENT_ID=" +
                    //   JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                    //   "&CALLBACK_URL=" +
                    //   encodeURIComponent(
                    //     `${addUrlPerFix(
                    //       process.env.VUE_APP_CRMSA_URL
                    //     )}/bid/bidFlowIndexSub?schemeId=${
                    //       row.schemeId
                    //     }&noticeStartTime=${
                    //       new Date(row.noticeTimeStart).getTime()
                    //       // row.noticeTimeStart
                    //     }&noticeEndTime=${
                    //       row.noticeTimeEnd
                    //     }&schemeName=${row.schemeName}&schemeCode=${
                    //       row.schemeCode
                    //     }${
                    //       this.supCode || row.supCode || objSession.supCode
                    //         ? "&supCode=" +
                    //           (this.supCode || row.supCode || objSession.supCode)
                    //         : ""
                    //     }&supName=${
                    //       JSON.parse(sessionStorage.usedSupInfo)?.supName
                    //     }&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                    //       JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                    //     }`
                    //   )
                  );
                } else {
                  encBlackList({
                    ids: [objSession.supCode],
                    purchaseUnitId: Number(row.opUnitId)
                  }).then(res => {
                    if (res.data.data.isJoin === "0") {
                      this.$message({
                        dangerouslyUseHTMLString: true,
                        message: res.data.data.errMsg,
                        type: "error",
                        showClose: true,
                        ccuiCustom: true
                      });
                    } else {
                      let obj = {
                        schemeId: row.schemeId,
                        noticeId: row.noticeId,
                        opUnitName: row.opUnitName,
                        opUnitId: row.opUnitId,
                        purchaseType: row.purchaseType,
                        schemeStatus: row.schemeStatus,
                        supplierFlag: 1,
                        noticeTypeName: row.noticeTypeName
                      };

                      if (row.checkFlag) {
                        obj.checkFlag = row.checkFlag;
                      }
                      let objs = JSON.parse(
                        sessionStorage.getItem("usedSupInfo")
                      );
                      if (objs?.supCode) {
                        obj.supCode =
                          row.supCode ||
                          objs.supCode ||
                          objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                          "";
                        obj.encSupCode =
                          row.encSupCode ||
                          objs.encSupCode ||
                          objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                          "";
                        obj.supName =
                          row.supName ||
                          objs.supName ||
                          objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                          "";
                      }
                      this.$router.push({
                        path: "/fenBaoDetail",
                        query: obj
                      });
                    }
                  });
                }
              });
            } else {
              let obj = {
                schemeId: row.schemeId,
                noticeId: row.noticeId,
                opUnitName: row.opUnitName,
                opUnitId: row.opUnitId,
                purchaseType: row.purchaseType,
                schemeStatus: row.schemeStatus,
                supplierFlag: 1,
                noticeTypeName: row.noticeTypeName
              };
              if (row.checkFlag) {
                obj.checkFlag = row.checkFlag;
              }
              let objs = objSession;
              // console.log(objs, "obj...");
              if (objs?.supCode) {
                obj.supCode =
                  row.supCode ||
                  objs.supCode ||
                  objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                  "";
                obj.encSupCode =
                  row.encSupCode ||
                  objs.encSupCode ||
                  objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                  "";
                obj.supName =
                  row.supName ||
                  objs.supName ||
                  objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                  "";
              }
              this.$router.push({
                path: "/fenBaoDetail",
                query: obj
              });
            }
          } else {
            let url = this.$router.resolve({
              path: "viewNoticeDetail",
              query: {
                schemeId: row.schemeId,
                schemeCode: row.schemeCode,
                schemeName: row.schemeName,
                noticeId: row.noticeId,
                opUnitName: row.opUnitName,
                opUnitId: row.opUnitId,
                purchaseType: row.purchaseType,
                schemeStatus: row.schemeStatus,
                checkFlag: row.checkFlag,
                supCode: row.supCode,
                supName: row.supName,
                type: row.noticeType
              }
            });
            window.location.href = url.href;
          }
        }
      }
    },
    //点击详情页面相关公告列表标题跳转
    handleNoticeTitle(row) {
      store.dispatch("setPageLoading", true);
      // console.log(row.purStep);
      let type = 0;
      let isSimple = true;
      //18 -> 评标结果公示  13->流标  14->补遗  16，17 -> 中标通知
      switch (row.purStep) {
        case "13":
          type = "7"; //流标
          break;
        case "14":
          type = "6";
          break;
        case "16":
          type = "5";
          break;
        case "17":
          type = "5";
          break;
        case "18":
          type = "3";
          break;
        default:
          isSimple = false;
          break;
      }
      if (isSimple) {
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetail",
          query: {
            type: type,
            noticeTypeName: this.formOptions.typeOptions.filter(
              item => item.value == type
            )[0].label,
            schemeId: row.schemeId,
            schemeName: row.schemeName,
            schemeCode: row.schemeCode,
            noticeId: row.noticeId,
            opUnitName: row.opUnitName,
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          }
        });
        window.open(url.href, "_blank");
      } else {
        this.handleView(
          Object.assign({}, row, {
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          })
        );
      }
      store.dispatch("setPageLoading", false);
    },
    //点击详情页面相关公告列表标题跳转
    handleNoticeTitleFB(row) {
      store.dispatch("setPageLoading", true);
      let type = 0;
      let isSimple = true;
      //18 -> 评标结果公示  13->流标  14->补遗  16，17 -> 中标通知
      switch (row.purStep) {
        case "13":
          type = "8";
          break;
        case "14":
          type = "7";
          break;
        case "16":
          type = "4";
          break;
        case "17":
          type = "4";
          break;
        case "18":
          type = "3";
          break;
        default:
          isSimple = false;
          break;
      }
      if (isSimple) {
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetailFB",
          query: {
            type: type,
            schemeId: row.schemeId,
            noticeId: row.noticeId,
            opUnitName: row.opUnitName,
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          }
        });
        window.open(url.href, "_blank");
      } else {
        this.handleViewFB(
          Object.assign({}, row, {
            supCode: this.$route.query.supCode,
            supName: this.$route.query.supName
          })
        );
      }
      store.dispatch("setPageLoading", false);
    },

    //查看详情
    handleViewFB(row) {
      store.dispatch("setPageLoading", true);
      if (
        row.supCode &&
        (row.lscpcNoticeType == 1 || row.lscpcNoticeType == 2)
      ) {
        let obj = {
          schemeId: row.schemeId,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          schemeStatus: row.schemeStatus,
          supplierFlag: 1,
          noticeTypeName: row.lscpcNoticeTypeName,
          type: row.lscpcNoticeType
        };

        if (row.checkFlag) {
          obj.checkFlag = row.checkFlag;
        }
        let objs = JSON.parse(sessionStorage.getItem("usedSupInfo"));
        console.log(objs, "obj...");
        if (row.supCode) {
          obj.supCode =
            row.supCode ||
            objs.supCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
            "";
          obj.encSupCode =
            row.encSupCode ||
            objs.encSupCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
            "";
          obj.supName =
            row.supName ||
            this.$route.query.supName ||
            objs.supName ||
            objs.getSupInfoByLoginInfoRspBOList[0].supName ||
            "";
        }
        let url = this.$router.resolve({
          path: "/fenBaoDetail",
          query: obj
        });
        window.open(url.href, "_blank");

        // querySupJoinFlag({
        //   schemeId: row.schemeId,
        //   supCode: row.supCode
        // }).then(res => {
        //   if (res.data.data.isJoin == 1) {
        //     return window.open(
        //       addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
        //         "?CLIENT_ID=" +
        //         JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
        //         "&CALLBACK_URL=" +
        //         encodeURIComponent(
        //           `${addUrlPerFix(
        //             process.env.VUE_APP_CRMSA_URL
        //           )}/bid/bidFlowIndexSub?schemeId=${
        //             row.schemeId
        //           }&noticeStartTime=${row.noticeTimeStart}&noticeEndTime=${
        //             row.noticeTimeEnd
        //           }&schemeName=${row.schemeName}&schemeCode=${row.schemeCode}${
        //             this.supCode || row.supCode
        //               ? "&supCode=" + (this.supCode || row.supCode)
        //               : ""
        //           }&supName=${
        //             JSON.parse(sessionStorage.usedSupInfo)?.supName
        //           }&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
        //             JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
        //           }`
        //         )
        //     );
        //   } else {
        //     encBlackList({
        //       ids: [row.supCode],
        //       purchaseUnitId: Number(row.purchaseUnitId)
        //     }).then(res => {
        //       if (res.data.data.isJoin === "0") {
        //         this.$message({
        //           dangerouslyUseHTMLString: true,
        //           message: res.data.data.errMsg,
        //           type: "error",
        //           showClose: true,
        //           ccuiCustom: true
        //         });
        //       } else {
        //         let obj = {
        //           schemeId: row.schemeId,
        //           noticeId: row.noticeId,
        //           opUnitName: row.opUnitName,
        //           opUnitId: row.opUnitId,
        //           purchaseType: row.purchaseType,
        //           schemeStatus: row.schemeStatus,
        //           supplierFlag: 1,
        //           noticeTypeName: row.lscpcNoticeTypeName,
        //           type: row.lscpcNoticeType
        //         };

        //         if (row.checkFlag) {
        //           obj.checkFlag = row.checkFlag;
        //         }
        //         let objs = JSON.parse(sessionStorage.getItem("usedSupInfo"));
        //         console.log(objs, "obj...");
        //         if (row.supCode) {
        //           obj.supCode =
        //             row.supCode ||
        //             objs.supCode ||
        //             objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
        //             "";
        //           obj.encSupCode =
        //             row.encSupCode ||
        //             objs.encSupCode ||
        //             objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
        //             "";
        //           obj.supName =
        //             row.supName ||
        //             this.$route.query.supName ||
        //             objs.supName ||
        //             objs.getSupInfoByLoginInfoRspBOList[0].supName ||
        //             "";
        //         }
        //         let url = this.$router.resolve({
        //           path: "/fenBaoDetail",
        //           query: obj
        //         });
        //         window.open(url.href, "_blank");
        //       }
        //     });
        //   }
        // });
      } else {
        let obj = {
          schemeId: row.schemeId,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          schemeStatus: row.schemeStatus,
          supplierFlag: 1,
          noticeTypeName: row.lscpcNoticeTypeName,
          type: row.lscpcNoticeType
        };
        if (row.checkFlag) {
          obj.checkFlag = row.checkFlag;
        }
        let objs = JSON.parse(sessionStorage.getItem("usedSupInfo"));
        console.log(objs, "obj...");
        if (row.supCode) {
          obj.supCode =
            row.supCode ||
            objs.supCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
            "";
          obj.encSupCode =
            row.encSupCode ||
            objs.encSupCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
            "";
          obj.supName =
            row.supName ||
            this.$route.query.supName ||
            objs.supName ||
            objs.getSupInfoByLoginInfoRspBOList[0].supName ||
            "";
        }
        let url = this.$router.resolve({
          path: "/viewNoticeDetailFB",
          query: obj
        });
        window.open(url.href, "_blank");
      }
      store.dispatch("setPageLoading", false);
    },
    //点击首页类目名称进入搜索页，并带过去条件
    handleClickCategory(item) {
      let url = this.$router.resolve({
        path: "/procurementNotice",
        // path: "/searchList",
        query: {
          categoryCode: item.categoryCode,
          categoryName: encodeURIComponent(item.categoryName)
        }
      });
      window.open(url.href, "_blank");
    },

    //详情页面 该单位还在采购 点击更多
    handleViewCommendUnit() {
      let url = this.$router.resolve({
        path: "/procurementNotice"
        // path: "/searchList"
      });
      window.open(url.href, "_blank");
    }

    //首页点击邀请公告跳转页面
    /*handleClickInviteNotice(item) {
      if (item.noticeStatus === "3" && item.checkFlag === "1") {
        this.signUp(item);
      } else if (item.checkFlag === "2" && item.schemeStatus === "3") {
        this.signUp(item);
      } else {
        this.perform(item);
      }
    }*/
  }
};
